import { render, staticRenderFns } from "./PixPayment.vue?vue&type=template&id=3c7ba5c6&scoped=true&"
import script from "./PixPayment.vue?vue&type=script&lang=ts&"
export * from "./PixPayment.vue?vue&type=script&lang=ts&"
import style0 from "./PixPayment.vue?vue&type=style&index=0&id=3c7ba5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7ba5c6",
  null
  
)

export default component.exports